import { purchaseOrderIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const bulkDeletePurchaseOrders = {
  name: "bulkDeletePurchaseOrders" as const,
  input: z.object({ purchaseOrderIds: z.array(purchaseOrderIdFormat.schema) }),
  output: z.object({ success: z.boolean() }),
};
